import React, { useEffect, useState } from 'react';
import Highlighter from 'react-highlight-words';
import { connect } from 'react-redux';
import useCampaignSearchSelected, { checkIfTermNotAvailableInLanguaje } from '@/hooks/useCampaignSearchSelected';
import { setCampaignSearchSelectedCoincidendeFieldId } from '@/redux/Campaign/campaign.action';
import { getCampaignInfo, getCampaignSearch } from '@/redux/Campaign/campaign.reducer';
import { getHeaderLanguage } from '@/redux/Header/header.reducer';
import { CampaignSearch } from '@/types';
import styles from './HighlightText.module.scss';

type HighlightTextProps = {
  children: React.ReactElement | string;
  campaignSearch: CampaignSearch;
  isTitle?: boolean;
  headerLanguage: string;
  fieldId: string;
  fieldPath: string[];
  fieldType: string;
  setSelectedFieldId: (fieldId: string) => void;
};

const HighlightText: React.FC<HighlightTextProps> = (props) => {
  const { children, campaignSearch, isTitle = false, headerLanguage, fieldId, fieldPath, fieldType, setSelectedFieldId } = props;
  const [searchedText, setSearchedText] = useState('');
  const { campaignSearchSelected } = useCampaignSearchSelected(fieldPath, fieldType);

  const termInTranslation = checkIfTermNotAvailableInLanguaje(campaignSearch?.fieldSelected?.field, headerLanguage);
  const isFieldSelected = (isTitle && campaignSearch?.fieldSelected?.field.path.split('.')[0] === 'title' && !termInTranslation)
    || campaignSearchSelected;
  const isTitleInTranslation = isTitle && termInTranslation && campaignSearch?.fieldSelected?.field.path.split('.')[0] === 'title';

  useEffect(() => {
    setSearchedText(campaignSearch?.active ? campaignSearch?.searchedText : '');
  }, [campaignSearch]);

  // If we found a result in some field, then set de element id in redux to retrieve it on the CR detail and make automatic
  // scroll to it
  useEffect(() => {
    if (campaignSearch?.active && campaignSearch?.resultCounter > 0
      && campaignSearchSelected && fieldId !== campaignSearch?.selectedCoincidenceFieldId) {
      if (campaignSearch?.searchedText) setSelectedFieldId(fieldId);
    }
  }, [campaignSearchSelected]);

  return (
    <Highlighter
      className={isTitleInTranslation ? styles.TitleInTranslation : ''}
      id="highlightTextSearched"
      highlightClassName={isFieldSelected ? styles.Selected : styles.NotSelected}
      searchWords={[searchedText]}
      autoEscape
      caseSensitive={false}
      textToHighlight={children || ''}
    />
  );
};

const mapStateToProps = (state) => ({
  campaignSearch: getCampaignSearch(state),
  headerLanguage: getHeaderLanguage(state) || getCampaignInfo(state)?.defaultLanguage,
});

const actionCreators = {
  setSelectedFieldId: setCampaignSearchSelectedCoincidendeFieldId,
};

export default connect(mapStateToProps, actionCreators)(HighlightText);
